import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LDClient, LDContext, LDEvaluationDetail, initialize } from 'launchdarkly-js-client-sdk';
import { StartupService } from './startup.service';

@Injectable({ providedIn: 'root' })
export class LaunchDarklyService {
    private readonly startUp = inject(StartupService);

    private ldClient: LDClient;
    private flagDetail: Map<string, LDEvaluationDetail> = new Map<string, LDEvaluationDetail>() ;

   
    
    constructor() {
    }

    public getFeatureFlagDetail(flagName: string[]): Observable<Map<string, LDEvaluationDetail>> {
        return new Observable((observer) => {
            try {
                const user: LDContext = {
                     kind: 'environmentInfo',
                     key: 'context-environmentInfo'
                };
                this.ldClient = initialize(this.startUp.launchDarklyClientID, user);
                this.ldClient.on('ready', () => {
                    flagName.forEach((fname) => {
                      this.flagDetail.set(fname, this.ldClient.variationDetail(fname, {}));
                    });
                    observer.next(this.flagDetail);
                    observer.complete();
                });
            } catch (error) {
                observer.error(error);
            }
        });
    }

}